<template>
    <div>
        <div class="d-inline-flex mr-2">
            <button @click="integrate" type="button" class="btn btn-facebook"
                data-toggle="tooltip" data-html="true"
                title="Integrates with Facebook Pages and enables sync reviews."
            >
                <i class="fab fa-facebook-f"></i>
                {{ facebook_integrated_text }}
            </button>
        </div>

        <div class="d-inline-flex" v-if="integrated">
            <p class="mr-2">With Page:</p>

            <img class="mr-2" style="max-height: 30px; margin-top: -3px"
                :src="form.picture">

            <p>{{ form.name }}</p>

            <button class="btn btn-sm btn-danger"
                style="margin-top: -3px; margin-left: 5px;"
                @click="showRemoveModal">Remove</button>
        </div>

        <choose-facebook-pages-modal
            ref="modal"
            :user-token="user_token"
            :page="selected_page"
            @selected-page="onPageSelect"
            @hide="close"
            @save="save"
        />

        <modal ref="fbRemoveModal" :has-footer="false" :centered="true">

            <template slot="title">Remove Facebook Page Integration</template>

            Are you sure you want to remove this Facebook page integration and all associated reviews?

            <div class="flex my-3 text-center">
                <button class="btn btn-danger mr-2" @click="onRemoveClicked">Remove</button>
                <button class="btn btn-default" @click="onCancelClicked">Cancel</button>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        props: ['integration'],

        data() {
            return {
                form             : new Form(),
                selected_page    : null,
                user_token       : null,
                should_open_modal: false,
            };
        },

        watch: {
            integration: {
                immediate: true,
                handler() {
                    if (this.integration) {
                        FB.getLoginStatus(this.onFacebookConnected.bind(this));

                        this.form = new Form({
                            location_id: this.integration.id
                        });

                        if (this.integration.facebook_page) {
                            this.selected_page = this.integration.facebook_page;

                            this.form.page_id = this.integration.facebook_page.page_id;
                            this.form.name    = this.integration.facebook_page.name;
                            this.form.picture = this.integration.facebook_page.picture;
                            this.form.token   = this.integration.facebook_page.token;
                        }
                        return;
                    }

                    this.form = new Form();
                    this.selected_page = null;
                }
            },
        },

        computed: {
            integrated() {
                return !!this.integration && !!this.integration.facebook_page;
            },

            facebook_integrated_text() {
                return this.integrated
                    ? `Integrated`
                    : "Integrate with facebook page";
            },
        },

        methods: {
            integrate() {
                this.login()
                    .then(this.onFacebookConnected.bind(this))
                    .then(() => this.should_open_modal = true)
            },

            login() {
                return new Promise((resolve, reject) => {
                    FB.login(response => resolve(response), {
                        scope: "public_profile, email, manage_pages, publish_pages, pages_messaging"
                    });
                });
            },

            onFacebookConnected(response) {
                if (response.status === "connected") {
                    let short_token = response.authResponse.accessToken;
                    this.requestLongToken(short_token);
                }

                return response;
            },

            requestLongToken(access_token) {
                return this.$http.post(this.$laroute.route('api.integrations.facebook-token'), {
                    access_token
                })
                .then(this.setLongToken.bind(this))
                .then(this.openModalIfRequested.bind(this))
                .catch(this.onRequestTokenFail.bind(this));
            },

            setLongToken(response) {
                if (response.status !== 200 || !response.data.access_token) {
                    return Promise.reject({
                        error: {message: "Error to request facebook token", response}
                    });
                }
                this.user_token = response.data.access_token;
                return response;
            },

            openModal() {
                this.$refs.modal.open();
                this.$emit('show', true);
            },

            close() {
                this.$emit('hide');
                this.should_open_modal = false;
            },

            save(page) {
                this.form.name    = page.name;
                this.form.page_id = page.id;
                this.form.token   = page.access_token
                this.form.picture = page.picture.data.url;

                return this.form.put(this.$laroute.route('location-facebook-pages.update', {
                    location: this.form.location_id
                }))
                .then(({data}) => {
                    swal.fire({
                        title: 'Location Saved!',
                        type: 'success',
                    }).then(() => {
                        this.$emit('save-integration', data.id);
                        this.$refs.modal.closeEdit();
                    });
                })
                .catch(error => console.error(error));
            },

            openModalIfRequested() {
                if (this.should_open_modal) this.openModal();
            },

            onPageSelect(page) {
                this.selected_page = page;
            },

            onRequestTokenFail(error) {
                console.error("ERROR requesting facebook page token", error);
            },

            showRemoveModal() {
                this.$refs.fbRemoveModal.open();
            },

            onRemoveClicked() {
                this.form.delete(this.$laroute.route('location-facebook-pages.delete', {
                    location: this.form.location_id
                })).then(({data}) => {
                    this.integration.facebook_page = null;
                    this.$alert({
                        title: 'Facebook Page Integration Removed',
                        type: 'success',
                        text: ''
                    }).then(() => {
                            this.$refs.fbRemoveModal.close();
                    });
                }).catch(error => console.error(error));
            },

            onCancelClicked() {
                this.$refs.fbRemoveModal.close();
            }
        }
    };
</script>
